import ManageTokenService from '@/services/ManageTokenService';
import CustomStyle from '@/components/Common/CustomStyle';

export default {
  name: 'ConfirmMessagePassword',

  components: { CustomStyle },

  props: [],

  data() {
    return {};
  },

  computed: {
    additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    },
  },

  mounted() {
    setTimeout(() => this.handleRedirectToPlatform(), 3000);
  },

  methods: {
    handleRedirectToPlatform() {
      ManageTokenService.removeTokenFromStorage();
      const platformUrl = this.$store.getters['authServicesPoints/platformUrl'];
      window.location.href = platformUrl;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/AuthLoginRegisterPage/ConfirmMessagePassword/component.js